import axios from 'axios';

// In production (Vercel), REACT_APP_API_URL must be set to your Render backend URL
// e.g. https://norix-backend.onrender.com/api
// In development, the React proxy forwards /api to localhost:5000
const baseURL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL,
  timeout: 300000, // 5 minutes — needed for large video uploads
});

api.interceptors.request.use((config) => {
  const userInfo = localStorage.getItem('norixUser');
  if (userInfo) {
    try {
      const { token } = JSON.parse(userInfo);
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch (e) {
      // ignore bad JSON
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('norixUser');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
